import { Box, CircularProgress, Typography } from "@mui/material";
import PaymentHeader from "./PaymentHeader";
import { CustomContainer, PlanDetails, PlanHeader } from "./style";
import { NavigatePrevIcon, PaymentTickIcon } from "../../assets/Icons";
import { CustomButton } from "../../globalStyle";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { currentPlanSelector } from "../../store/account/selector";
import { useEffect, useState } from "react";
import { AccountSagaActions } from "../../store/account/sagas";
import routeConstant from "../../utils/routeConstant";
import { useTheme } from "styled-components";
import { AdDrawerStyledButton } from "../commonComponents/adDetails/style";
import { PaymentSagaActions } from "../../store/payment/sagas";
import { getRedirectUrl } from "../../utils/redirect";
import {
  activeSubscriptionSelector,
  isButtonLoadingSelector,
  userCardDetailsSelector,
} from "../../store/payment/selector";
import { AccountReducerAction } from "../../store/account/slice";
import { InviteSectionCancelRequestBtn } from "../../pageComponents/settings/style";
import DeleteConfirmationModal from "../modals/deleteConfirmationModal";
import { MetaDataSagaActions } from "../../store/metadata/sagas";

const PreviewPage = () => {
  const { subscriptionId } = useParams();
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const [removeMember, setRemoveMember] = useState<string | null>(null);
  // Assuming you have a selector for seat removal loading, otherwise set to false
  const isRemoving = false; // Replace with useSelector if available
  const seatSeactionLoader = { type: "removeSeat", loading: isRemoving };

  const currentPlan = useSelector(currentPlanSelector);
  const isButtonloading = useSelector(isButtonLoadingSelector);
  const userCardDetails = useSelector(userCardDetailsSelector);
  const activePlan = useSelector(activeSubscriptionSelector);

  useEffect(() => {
    dispatch(PaymentSagaActions.fetchActiveSubscription());
  }, [dispatch]);

  const handleNavigate = (url: string) =>
    navigate(getRedirectUrl(url), { replace: true });

  useEffect(() => {
    dispatch(AccountSagaActions.getCurrentPlan({ id: subscriptionId }));

    return () => {
      dispatch(AccountReducerAction.setCurrentPlan({}));
    };
  }, [subscriptionId]);

  useEffect(() => {
    dispatch(PaymentSagaActions.GetUserCardDetails());
  }, [dispatch]);

  const handleDownGraderedPlan = () => {
    dispatch(
      PaymentSagaActions.getDownGradePlan({
        planId: subscriptionId,

        handleNavigate,
      })
    );
  };

  const handleRemoveSeat = async () => {
    if (!removeMember) return;

    try {
      dispatch(
        MetaDataSagaActions.removeSeatMember({
          seatId: removeMember,
          closeModal: () => {
            setRemoveMember(null);
            // Refetch the current plan to get updated calculations after successful removal
            dispatch(AccountSagaActions.getCurrentPlan({ id: subscriptionId }));
          },
        })
      );
    } catch (error) {
      console.error("Error removing seat:", error);
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#FFF",
        gap: "25px",
      }}
    >
      <PaymentHeader />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "25px",
          maxWidth: "1100px",
          marginBottom: "30px",
        }}
      >
        <Box sx={{ display: "flex", width: "100%" }}>
          {currentPlan?._id && (
            <AdDrawerStyledButton onClick={() => navigate(-1)}>
              <NavigatePrevIcon />
              Back
            </AdDrawerStyledButton>
          )}
          <Typography
            style={{
              fontWeight: 700,
              fontSize: "32px",
              color: "#414042",
              textAlign: "center",
              flex: 1,
            }}
          >
            Cart
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap="30px">
          {!currentPlan?.name ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "20px",
              }}
            >
              <CircularProgress size="50px" />
            </Box>
          ) : (
            <>
              <CustomContainer>
                <Box>
                  <PlanHeader>
                    <Box>
                      <Typography
                        variant="body1"
                        sx={{ fontSize: 24, fontWeight: 600 }}
                      >
                        {currentPlan?.name}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontSize: 16, fontWeight: 500 }}
                      >
                        {currentPlan?.description}
                      </Typography>
                    </Box>
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 32, fontWeight: 700 }}
                    >
                      ${currentPlan?.amount?.toFixed(2)}
                    </Typography>
                  </PlanHeader>
                  <PlanDetails>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                        padding: "30px 30px 0",
                      }}
                    >
                      Plan Includes:{" "}
                    </Typography>
                    {currentPlan?.featureList?.map(
                      (perk: string, index: number) => (
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                            paddingX: "30px",
                          }}
                        >
                          <PaymentTickIcon />
                          <Box sx={{ fontSize: 16, fontWeight: 500 }}>
                            {perk}
                          </Box>
                        </Box>
                      )
                    )}

                    <Box
                      sx={{
                        maxHeight: "30rem",
                        padding: "1rem",
                        borderRadius: "0.75rem",
                        overflowY: "auto",
                        overflowX: "hidden",
                        backgroundColor: "#f9f9f9",
                        "::-webkit-scrollbar": {
                          width: "6px",
                        },
                        "::-webkit-scrollbar-track": {
                          backgroundColor: "#f0f0f0",
                          borderRadius: "3px",
                        },
                        "::-webkit-scrollbar-thumb": {
                          backgroundColor: "#d0d0d0",
                          borderRadius: "3px",
                          "&:hover": {
                            backgroundColor: "#b0b0b0",
                          },
                        },
                      }}
                    >
                      {(() => {
                        const seatBlock =
                          currentPlan?.seatDetails?.seatBlock || [];

                        return seatBlock.map((member: any, index: number) => {
                          const isEnabled = member?.isEnable;
                          const isFreeSeat = member?.isFree;

                          return (
                            <Box
                              key={member._id || index}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "1.25rem",
                                marginBottom: "1rem",
                                border: "1px solid #e8e8e8",
                                borderRadius: "0.875rem",
                                backgroundColor: "#ffffff",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
                                transition: "all 0.2s ease",
                                "&:hover": {
                                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                  borderColor: "#d0d0d0",
                                },
                                flexWrap: "wrap",
                                rowGap: "1rem",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  flex: "1 1 auto",
                                  gap: "1rem",
                                  minWidth: 0,
                                  flexWrap: "wrap",
                                }}
                              >
                                <Box
                                  sx={{
                                    width: "2.75rem",
                                    height: "2.75rem",
                                    borderRadius: "50%",
                                    background:
                                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "1rem",
                                    fontWeight: 600,
                                    color: "#ffffff",
                                    flexShrink: 0,
                                    boxShadow:
                                      "0 2px 4px rgba(102, 126, 234, 0.3)",
                                  }}
                                >
                                  {index + 1}
                                </Box>

                                <Box
                                  sx={{
                                    flexShrink: 1,
                                    minWidth: "15rem",
                                    maxWidth: "15rem",
                                  }}
                                >
                                  <Typography
                                    fontSize="1rem"
                                    fontWeight={600}
                                    color="#1a1a1a"
                                    sx={{
                                      textOverflow: "ellipsis",
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      marginBottom: "0.25rem",
                                    }}
                                  >
                                    {member?.fullName || `Seat ${index + 1}`}
                                  </Typography>
                                  <Typography
                                    fontSize="0.875rem"
                                    color="#999999"
                                    sx={{
                                      textOverflow: "ellipsis",
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {member?.userEmail}
                                  </Typography>
                                </Box>
                              </Box>

                              <Box
                                sx={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                  gap: "0.75rem",
                                  flexShrink: 0,
                                }}
                              >
                                {!isFreeSeat && !isEnabled && (
                                  <Box
                                    component="button"
                                    onClick={() => setRemoveMember(member?._id)}
                                    sx={{
                                      padding: "0.625rem 1.25rem",
                                      backgroundColor: "#ff4757",
                                      color: "#ffffff",
                                      border: "none",
                                      borderRadius: "0.625rem",
                                      fontSize: "0.875rem",
                                      fontWeight: 600,
                                      cursor: "pointer",
                                      transition: "all 0.2s ease",
                                      "&:hover": {
                                        backgroundColor: "#ff3838",
                                        transform: "translateY(-1px)",
                                        boxShadow:
                                          "0 4px 8px rgba(255, 71, 87, 0.3)",
                                      },
                                      "&:active": {
                                        transform: "translateY(0px)",
                                        boxShadow:
                                          "0 2px 4px rgba(255, 71, 87, 0.2)",
                                      },
                                      "&:disabled": {
                                        backgroundColor: "#cccccc",
                                        cursor: "not-allowed",
                                        opacity: 0.6,
                                      },
                                    }}
                                  >
                                    Remove
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          );
                        });
                      })()}
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        alignItems: "end",
                        gap: "20px",
                        borderTop: `1px solid ${theme.colors.border1}`,
                        padding: "30px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "end",
                          flexDirection: "column",
                          gap: "5px",
                        }}
                      >
                        {currentPlan?.deductionAmount ? (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                              textAlign: "right",
                            }}
                          >
                            {/* Plan Price */}
                            <Typography
                              sx={{
                                fontSize: "20px",
                                fontWeight: 500,
                                color: "#414042",
                              }}
                            >
                              Plan Price: +$
                              {currentPlan?.amount?.toFixed(2) ?? "0.00"}
                            </Typography>

                            {/* Total Paid Amount (Per Seat × Count) */}
                            {currentPlan?.paidSeatCount ? (
                              <>
                                <Typography
                                  sx={{
                                    fontSize: "20px",
                                    fontWeight: 500,
                                    color: "#414042",
                                  }}
                                >
                                  Per Seat Amount: +$
                                  {currentPlan?.totalCurrentSeatAmount?.toFixed(
                                    2
                                  ) ?? "0.00"}{" "}
                                  × Paid Seat Count:{" "}
                                  {currentPlan?.paidSeatCount ?? 0} = Total Paid
                                  Amount: +$
                                  {(
                                    (currentPlan?.totalCurrentSeatAmount ?? 0) *
                                    (currentPlan?.paidSeatCount ?? 0)
                                  ).toFixed(2)}
                                </Typography>

                                {/* Unused Seat Balance */}
                                <Typography
                                  sx={{
                                    fontSize: "20px",
                                    fontWeight: 500,
                                    color: "#414042",
                                  }}
                                >
                                  Unused Seat Balance: -$
                                  {currentPlan?.refundTotal?.toFixed(2) ??
                                    "0.00"}
                                </Typography>
                              </>
                            ) : null}
                            {/* Total Seat Payment */}
                            <Typography
                              sx={{
                                fontSize: "20px",
                                fontWeight: 500,
                                color: "#414042",
                              }}
                            >
                              Total Seat Payment: +$
                              {currentPlan?.tatalSeatPayment?.toFixed(2) ??
                                "0.00"}
                            </Typography>

                            {/* Remaining Balance Deduction */}
                            <Typography
                              sx={{
                                fontSize: "20px",
                                fontWeight: 500,
                                color: "#414042",
                              }}
                            >
                              Remaining Balance Deduction: -$
                              {currentPlan?.deductionAmount?.toFixed(2) ??
                                "0.00"}
                            </Typography>

                            {/* Total Payable */}
                            <Typography
                              sx={{
                                fontSize: "20px",
                                fontWeight: 600,
                                color: "#414042",
                              }}
                            >
                              Total Payable: $
                              {(
                                (currentPlan?.amount ?? 0) +
                                (currentPlan?.totalCurrentSeatAmount ?? 0) *
                                  (currentPlan?.paidSeatCount ?? 0) +
                                (currentPlan?.tatalSeatPayment ?? 0) -
                                (currentPlan?.refundTotal ?? 0) -
                                (currentPlan?.deductionAmount ?? 0)
                              ).toFixed(2)}
                            </Typography>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "5px",
                              textAlign: "right",
                            }}
                          >
                            {currentPlan?.amount && (
                              <Typography
                                sx={{
                                  fontSize: "20px",
                                  fontWeight: 500,
                                  color: "#414042",
                                }}
                              >
                                Plan Price: +$
                                {currentPlan?.amount?.toFixed(2) ?? "0.00"}
                              </Typography>
                            )}

                            {currentPlan?.tatalSeatPayment !== 0 && (
                              <Typography
                                sx={{
                                  fontSize: "20px",
                                  fontWeight: 500,
                                  color: "#414042",
                                }}
                              >
                                Total Seat Payment: +$
                                {currentPlan?.tatalSeatPayment?.toFixed(2) ??
                                  "0.00"}
                              </Typography>
                            )}

                            <Typography
                              sx={{
                                fontSize: "20px",
                                fontWeight: 600,
                                color: "#414042",
                              }}
                            >
                              Total: $
                              {(
                                (currentPlan?.amount ?? 0) +
                                (currentPlan?.tatalSeatPayment ?? 0)
                              ).toFixed(2)}
                            </Typography>
                          </Box>
                        )}
                        {activePlan?.activePlanDetails?.amount &&
                        activePlan?.planEndDate &&
                        activePlan?.activePlanDetails?.amount >
                          currentPlan?.amount ? (
                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontWeight: 500,
                              color: "#414042",
                            }}
                          >
                            Your current plan will continue until{" "}
                            {new Date(
                              activePlan?.planEndDate
                            ).toLocaleDateString("en-US", {
                              month: "2-digit",
                              day: "2-digit",
                              year: "numeric",
                            })}
                            , after which your subscription will be downgraded
                            as requested.
                          </Typography>
                        ) : null}
                      </Box>
                      {activePlan?.activePlanDetails?.amount &&
                      activePlan?.activePlanDetails?.amount >
                        currentPlan?.amount ? (
                        <CustomButton
                          style={{
                            fontSize: "16px",
                            color: "white",
                            borderRadius: "25px",
                            background:
                              "linear-gradient(94.04deg, #1c75bc 2.44%, #00aeef 112.73%)",
                            padding: "14px 30px",
                            height: "38px",
                          }}
                          onClick={handleDownGraderedPlan}
                          disabled={isButtonloading}
                        >
                          {isButtonloading && (
                            <CircularProgress
                              size={18}
                              color="inherit"
                              sx={{ marginRight: "4px" }}
                            />
                          )}
                          Confirm
                        </CustomButton>
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "20px",
                          }}
                        >
                          <CustomButton
                            style={{
                              fontSize: "16px",
                              color: "white",
                              borderRadius: "25px",
                              background:
                                "linear-gradient(94.04deg, #1c75bc 2.44%, #00aeef 112.73%)",
                              padding: "14px 30px",
                              height: "38px",
                            }}
                            onClick={() =>
                              navigate(
                                `${routeConstant?.paymentCheckout}/dropin/${subscriptionId}`
                              )
                            }
                          >
                            Checkout with New Card
                          </CustomButton>
                          {userCardDetails?.length ? (
                            <CustomButton
                              style={{
                                fontSize: "16px",
                                color: "white",
                                borderRadius: "25px",
                                background:
                                  "linear-gradient(94.04deg, #1c75bc 2.44%, #00aeef 112.73%)",
                                padding: "14px 30px",
                                height: "38px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                              onClick={() =>
                                navigate(routeConstant?.choosePaymentCard, {
                                  state: {
                                    subscriptionId,
                                    isSeatPurchase: false,
                                  },
                                })
                              }
                              disabled={isButtonloading}
                            >
                              {isButtonloading && (
                                <CircularProgress
                                  size={18}
                                  color="inherit"
                                  sx={{ marginRight: "4px" }}
                                />
                              )}
                              Checkout with Saved Card
                            </CustomButton>
                          ) : null}
                        </Box>
                      )}
                    </Box>
                  </PlanDetails>
                </Box>
              </CustomContainer>
            </>
          )}
        </Box>
      </Box>

      <DeleteConfirmationModal
        handleDelete={handleRemoveSeat}
        handleClose={() => setRemoveMember(null)}
        isOpen={!!removeMember}
        btnLabel="Confirm"
        loading={
          seatSeactionLoader?.type === "removeSeat" &&
          seatSeactionLoader?.loading
        }
        modalTitle="Remove Seat Confirmation"
        modalDescription={
          <>
            <Typography variant="body1" sx={{ mb: 0.5 }}>
              Are you sure you want to remove this seat?
            </Typography>

            <Box component="ul" sx={{ pl: 2, m: 0 }}>
              <Typography component="li" variant="body2" sx={{ mb: 0.25 }}>
                The assigned user and{" "}
                <strong>all their data will be permanently deleted</strong>.
              </Typography>
              <Typography component="li" variant="body2">
                You will not be charged for this seat in the next subscription
                cycle.
              </Typography>
            </Box>

            <Typography
              variant="caption"
              sx={{ display: "block", mt: 1, color: "text.secondary" }}
            >
              This action is irreversible.
            </Typography>
          </>
        }
      />
    </Box>
  );
};

export default PreviewPage;
